// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dropdown-menu { 
    display: inline-block;
    position: relative;
}


.dropdown-menu .dropdown-menu__trigger {
    font-size: 14px;
    cursor: pointer;
}
.dropdown-menu .dropdown-menu__trigger a:link {
    color: var(--main-text-color);
}
.dropdown-menu .dropdown-menu__trigger a:active,
.dropdown-menu .dropdown-menu__trigger a:hover,
.dropdown-menu .dropdown-menu__trigger a:visited {
    color: var(--main-text-color);
    filter: brightness(90%);
}


.dropdown-menu .dropdown-menu__body {
    position: absolute;
    top: 2.6em;
    right: 0;
    text-align: left;
    background-color: white; 
    border: thin solid var(--floating-menu-border-color);
    box-shadow: 0px 0px 5px -3px rgba(0,0,0,0.25);
    padding: 5px 0;
    z-index: 10;
    border-radius: 7px;
}


.dropdown-menu .dropdown-menu__body .dropdown-menu__header {
    border-bottom: thin solid var(--dropdown-menu-border-color);
}
.dropdown-menu .dropdown-menu__body .dropdown-menu__header .dropdown-menu__header-top {
    display: grid;
    grid-template-columns: 6fr 1fr;
    border-bottom: thin solid var(--dropdown-menu-border-color);
}
.dropdown-menu .dropdown-menu__body .dropdown-menu__header .dropdown-menu__header-title { 
    padding: 10px;
    font-weight: bold;
    white-space: nowrap;
}
.dropdown-menu .dropdown-menu__body .dropdown-menu__header .dropdown-menu__header-bottom {
    padding: 5px;
}


.dropdown-menu .dropdown-menu__body .dropdown-menu__item {
    display: block;
    white-space: nowrap;
    padding: 5px 20px;
}
.dropdown-menu .dropdown-menu__body a.dropdown-menu__item:link, 
.dropdown-menu .dropdown-menu__body a.dropdown-menu__item:visited {
    color: var(--main-text-color);
}

.dropdown-menu .dropdown-menu__body a.dropdown-menu__item:active,
.dropdown-menu .dropdown-menu__body a.dropdown-menu__item:hover {
    color: white;
    background-color: var(--primary-highlight-color);
}
.dropdown-menu .dropdown-menu__body .dropdown-menu__item a:active,
.dropdown-menu .dropdown-menu__body .dropdown-menu__item a:hover {
    color: white;
}

.dropdown-menu .dropdown-menu__body .dropdown-menu__item.dropdown-menu__item__disabled {
    display: block;
    white-space: nowrap;
    padding-left: 20px;
    color: var(--primary-color-light);
}

`, "",{"version":3,"sources":["webpack://./client/components/ui/DropdownMenu/DropdownMenu.css"],"names":[],"mappings":"AAAA;IACI,qBAAqB;IACrB,kBAAkB;AACtB;;;AAGA;IACI,eAAe;IACf,eAAe;AACnB;AACA;IACI,6BAA6B;AACjC;AACA;;;IAGI,6BAA6B;IAC7B,uBAAuB;AAC3B;;;AAGA;IACI,kBAAkB;IAClB,UAAU;IACV,QAAQ;IACR,gBAAgB;IAChB,uBAAuB;IACvB,oDAAoD;IACpD,6CAA6C;IAC7C,cAAc;IACd,WAAW;IACX,kBAAkB;AACtB;;;AAGA;IACI,2DAA2D;AAC/D;AACA;IACI,aAAa;IACb,8BAA8B;IAC9B,2DAA2D;AAC/D;AACA;IACI,aAAa;IACb,iBAAiB;IACjB,mBAAmB;AACvB;AACA;IACI,YAAY;AAChB;;;AAGA;IACI,cAAc;IACd,mBAAmB;IACnB,iBAAiB;AACrB;AACA;;IAEI,6BAA6B;AACjC;;AAEA;;IAEI,YAAY;IACZ,gDAAgD;AACpD;AACA;;IAEI,YAAY;AAChB;;AAEA;IACI,cAAc;IACd,mBAAmB;IACnB,kBAAkB;IAClB,iCAAiC;AACrC","sourcesContent":[".dropdown-menu { \n    display: inline-block;\n    position: relative;\n}\n\n\n.dropdown-menu .dropdown-menu__trigger {\n    font-size: 14px;\n    cursor: pointer;\n}\n.dropdown-menu .dropdown-menu__trigger a:link {\n    color: var(--main-text-color);\n}\n.dropdown-menu .dropdown-menu__trigger a:active,\n.dropdown-menu .dropdown-menu__trigger a:hover,\n.dropdown-menu .dropdown-menu__trigger a:visited {\n    color: var(--main-text-color);\n    filter: brightness(90%);\n}\n\n\n.dropdown-menu .dropdown-menu__body {\n    position: absolute;\n    top: 2.6em;\n    right: 0;\n    text-align: left;\n    background-color: white; \n    border: thin solid var(--floating-menu-border-color);\n    box-shadow: 0px 0px 5px -3px rgba(0,0,0,0.25);\n    padding: 5px 0;\n    z-index: 10;\n    border-radius: 7px;\n}\n\n\n.dropdown-menu .dropdown-menu__body .dropdown-menu__header {\n    border-bottom: thin solid var(--dropdown-menu-border-color);\n}\n.dropdown-menu .dropdown-menu__body .dropdown-menu__header .dropdown-menu__header-top {\n    display: grid;\n    grid-template-columns: 6fr 1fr;\n    border-bottom: thin solid var(--dropdown-menu-border-color);\n}\n.dropdown-menu .dropdown-menu__body .dropdown-menu__header .dropdown-menu__header-title { \n    padding: 10px;\n    font-weight: bold;\n    white-space: nowrap;\n}\n.dropdown-menu .dropdown-menu__body .dropdown-menu__header .dropdown-menu__header-bottom {\n    padding: 5px;\n}\n\n\n.dropdown-menu .dropdown-menu__body .dropdown-menu__item {\n    display: block;\n    white-space: nowrap;\n    padding: 5px 20px;\n}\n.dropdown-menu .dropdown-menu__body a.dropdown-menu__item:link, \n.dropdown-menu .dropdown-menu__body a.dropdown-menu__item:visited {\n    color: var(--main-text-color);\n}\n\n.dropdown-menu .dropdown-menu__body a.dropdown-menu__item:active,\n.dropdown-menu .dropdown-menu__body a.dropdown-menu__item:hover {\n    color: white;\n    background-color: var(--primary-highlight-color);\n}\n.dropdown-menu .dropdown-menu__body .dropdown-menu__item a:active,\n.dropdown-menu .dropdown-menu__body .dropdown-menu__item a:hover {\n    color: white;\n}\n\n.dropdown-menu .dropdown-menu__body .dropdown-menu__item.dropdown-menu__item__disabled {\n    display: block;\n    white-space: nowrap;\n    padding-left: 20px;\n    color: var(--primary-color-light);\n}\n\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
